export default __webpack_public_path__ + "3bf261f3a339f45c0dbc072a1c42ce52.svg";